<div><label class="info-label">{{title}}</label></div>
<fieldset [attr.aria-label]="title">
  <div *ngFor="let screenSizeFilterRange of screenSizeFilterRanges">
    <mat-checkbox
      tabindex="0"
      class="result-filter-cb"
      [checked]="screenSizeRangeIsSelected(screenSizeFilterRange)"
      (change)="onScreenSizeFilterChange(screenSizeFilterRange)"
      (keyup.enter)="onScreenSizeFilterChange(screenSizeFilterRange)">
      <span class="filter-label">{{filterMapper.getScreenSizeFilterLabel(screenSizeFilterRange)}}</span>
    </mat-checkbox>
    <div class="spacer-xx-small"></div>
  </div>
</fieldset>
